<div class="user-billing-container" *ngIf="userBillingDetails">
  <div class="account-type">
    <account-type [userBilling]="userBillingDetails"
                  [shouldReloadPage]="shouldReloadPage"
                  (afterUpdateSubscription)="afterUpdateSubscription($event)"
                  (requestReloadBilling)="reloadBilling()">
    </account-type>
  </div>
  <div class="horizontal-seperator"></div>
  <user-monthly-usage [userMonthlyUsage]="userMonthlyUsage"></user-monthly-usage>
</div>
<div class="bottombar">
</div>
<achoo-popup #UserBillingNotification
             [isNotification]="true"
             [modelTitle]="notificationTitle">
  <span>{{notificationContent}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/user/user-billing/user-billing.component.html